<template>
  <aRow>
    <aCol
      class="content-row"
      v-for="(item, index) in theList()"
      :key="index"
      :span="24"
    >
      <aRow class="tab-header" type="flex" justify="space-between">
        <aCol>
          <h3 class="cprimary">{{ index + 1 }} - {{ item.name }}</h3>
        </aCol>
        <aCol v-if="cancellationMode">
          <template
            v-if="
              !cancelSpecificTravelers &&
              salesAdditiveType === 'Alterar' &&
              item.travellers.length > 1
            "
          >
            <aButton
              class="f12"
              @click="onClickCancelSpecificTravelers(item, true)"
              size="small"
            >
              <b>Remover Viajantes</b>
            </aButton>

            <aDivider type="vertical" />
          </template>

          <template
            v-if="salesAdditiveType === 'Alterar' && cancelSpecificTravelers"
          >
            <aButton
              class="f12"
              size="small"
              @click="onClickCancelSpecificTravelers(item, false)"
            >
              <b>Fechar Viajantes</b>
            </aButton>
            <aDivider type="vertical" />
          </template>

          <aButton
            v-if="cancellationMode"
            class="red f12"
            size="small"
            @click="onClickOpenCancelModal(item)"
          >
            <b>{{
              salesAdditiveType === "Cancelar Venda"
                ? "Cancelar"
                : salesAdditiveType
            }}</b>
          </aButton>
        </aCol>
      </aRow>

      <ContractModalFlightRow
        ref="ContractModalFlightRow"
        type="view"
        :tempContract="tempContract"
        :cancelSpecificTravelers="cancelSpecificTravelers"
        :product="item"
        @onClickSaveTravellersToCancel="onClickOpenCancelModal"
      />
    </aCol>

    <aModal
      class="product-cancel-modal"
      :title="false"
      :visible="openCancelModal"
      :footer="false"
      :width="800"
      @cancel="onClickCloseCancelModal"
    >
      <CancelFlightModal
        v-if="openCancelModal"
        :productToCancel="productToCancel"
        :tempContract="tempContract"
        :salesAdditiveType="salesAdditiveType"
        :allContractData="allContractData"
        :productsToCancel="productsToCancel"
        :totalFees="totalFees"
        @onChangeCancelProductData="onChangeCancelProductData"
        @onFinishActions="onFinishActions"
      />
    </aModal>
  </aRow>
</template>

<script>
import formatThings from "@/mixins/general/formatThings.js";
import CancelFlightModal from "../modals/CancelFlightModal.vue";
import ContractModalFlightRow from "../sections/ContractModalFlightRow.vue";

export default {
  name: "ContractFlightDetails",
  props: {
    tempContract: Object,
    cancellationMode: Boolean,
    salesAdditiveType: String,
    productsToCancel: Array,
    allContractData: Object,
    totalFees: Number,
  },
  components: { CancelFlightModal, ContractModalFlightRow },
  mixins: [formatThings],
  data() {
    return {
      openCancelModal: false,
      productToCancel: {},
      cancelSpecificTravelers: false,
    };
  },
  methods: {
    onFinishActions() {
      this.$emit("onFinishActions");
    },
    onChangeCancelProductData(tempContract) {
      this.$emit("onChangeCancelProductData", tempContract);
    },
    onClickOpenCancelModal(flight) {
      this.productToCancel = flight;
      this.openCancelModal = true;
      this.cancelSpecificTravelers = false;
    },
    onClickCancelSpecificTravelers(item, status) {
      item;
      this.cancelSpecificTravelers = status;
    },
    onClickCloseCancelModal() {
      this.productToCancel = {};
      this.openCancelModal = false;
      this.$emit("onChangeCancelProductData", this.tempContract);
    },
    thePassenger(id) {
      let travellers = JSON.parse(this.tempContract.travellers_rows);
      let theTraveller = {};

      travellers.forEach((traveller) => {
        if (traveller.id == id) {
          theTraveller.name = `${
            this.tempContract[`traveller_${traveller.id}_first_name`]
          } ${this.tempContract[`traveller_${traveller.id}_last_name`]}`;

          theTraveller.birthday = `${
            this.tempContract[`traveller_${traveller.id}_birthday`]
          }`;

          if (this.tempContract[`traveller_${traveller.id}_gender`]) {
            theTraveller.gender = `${
              this.tempContract[`traveller_${traveller.id}_gender`]
            }`;
          }
        }
      });

      return theTraveller;
    },
    theProductInfo(product) {
      let allSections = [];
      product.sections.forEach((section) => {
        allSections.push({
          id: section.id,
          type: this.tempContract[
            `flight_${product.id}_section_${section.id}_type`
          ],
          origin:
            this.tempContract[
              `flight_${product.id}_section_${section.id}_origin`
            ],
          destination:
            this.tempContract[
              `flight_${product.id}_section_${section.id}_destination`
            ],
          class:
            this.tempContract[
              `flight_${product.id}_section_${section.id}_class`
            ],
          airline:
            this.tempContract[
              `flight_${product.id}_section_${section.id}_airline`
            ],
          duration:
            this.tempContract[
              `flight_${product.id}_section_${section.id}_duration`
            ],
          number:
            this.tempContract[
              `flight_${product.id}_section_${section.id}_number`
            ],
          stops:
            this.tempContract[
              `flight_${product.id}_section_${section.id}_stops`
            ],
          departure: `${this.formatMultiDates(
            this.tempContract[
              `flight_${product.id}_section_${section.id}_departure_date`
            ]
          )} ${
            this.tempContract[
              `flight_${product.id}_section_${section.id}_departure_time`
            ]
          }`,

          arrival: `${this.formatMultiDates(
            this.tempContract[
              `flight_${product.id}_section_${section.id}_arrival_date`
            ]
          )} ${
            this.tempContract[
              `flight_${product.id}_section_${section.id}_arrival_time`
            ]
          }`,
        });
      });

      let allTravellers = [];
      product.travellers.forEach((traveller) => {
        allTravellers.push({
          id: traveller.id,
          ...this.thePassenger(
            this.tempContract[`flight_${product.id}_traveller_${traveller.id}`]
          ),
        });
      });

      return {
        id: product.id,
        name: `AÉREO ${this.tempContract[`flight_${product.id}_type`]}`,
        type: this.tempContract[`flight_${product.id}_type`],
        sections: allSections,
        travellers: allTravellers,
      };
    },
    theList() {
      let arr = [];
      let contractedServices = JSON.parse(
        this.tempContract.contracted_services
      );

      if (contractedServices.includes("flight")) {
        -JSON.parse(this.tempContract["flight_sections_rows"]).forEach(
          (flight) => {
            const data = this.theProductInfo(flight);

            if (
              this.salesAdditiveType === "Cancelar Venda" ||
              !this.cancellationMode
            ) {
              arr.push(data);
            } else {
              if (this.productsToCancel.includes(`flight-${flight.id}`)) {
                arr.push(data);
              }
            }
          }
        );
      }

      return arr;
    },
  },
};
</script>

<style lang="scss">
.product-cancel-modal {
  .ant-modal-body {
    padding: 0;
    overflow: hidden;
    border-radius: 6px;
  }
  .ant-modal-close {
    margin-top: -50px;
    color: #fff;
    right: -18px;
  }
}
</style>

<style lang="sass" scoped>
.content-row
  background: #FFF
  padding: 10px
  border: 1px solid #ddd !important
  margin: 0 0 10px
  border-radius: 6px
  font-size: 13px
  font-weight: 500
  .tab-header
    margin-bottom: 15px
    color: #be4178
    border-bottom: 1px solid #ececec
    padding-bottom: 5px
    h3
      font-size: 14px
      font-weight: 600
      text-transform: uppercase
</style>
